import { render, staticRenderFns } from "./add_zhengji.vue?vue&type=template&id=4f1bb4bc&scoped=true&"
import script from "./add_zhengji.vue?vue&type=script&lang=js&"
export * from "./add_zhengji.vue?vue&type=script&lang=js&"
import style0 from "./add_zhengji.vue?vue&type=style&index=0&id=4f1bb4bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1bb4bc",
  null
  
)

export default component.exports